import ReactDOM from 'react-dom/client';
import './client/css/index.css';
import './client/css/dropdown.css';
import './client/css/header.css';
import './client/css/text.css';
import './client/css/colors.css';
import './client/css/inputs.css';
import './client/css/footer.css';
import './client/css/switch.css';
import './client/css/adaptives.css';
import { Index } from './app-index';
import { BrowserRouter } from 'react-router-dom';
import { InitService } from './common/services/init';
import { ServerErrorPage } from './client/components/layout/errors';

const initService = new InitService();


(async () => {
  const isValid = await initService.initAllAndValidate();

  ReactDOM
    .createRoot(document.getElementById("root") as HTMLElement)
    .render(
      <BrowserRouter>
        {
          isValid
            ? <Index />
            : <ServerErrorPage />
        }
      </BrowserRouter>
    )
})()
